
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/why-homelister",
      function () {
        return require("private-next-pages/why-homelister.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/why-homelister"])
      });
    }
  